import { Component, Inject, Input, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { navigation } from '../../navigation/navigation';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { DefaultDataService } from 'src/app/services/default-data.service';
import { ConstantsService } from 'src/app/services/constants.service';

// import { NavigationService } from '../../shared/services/navigation.service';

@Component({
  selector: 'fuse-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FuseNavbarComponent implements OnDestroy {
  //
  // Please note. The End2End Tests require Id for navBar items. We have updated the fuse nav-vertical-item.component.html
  // to include Id = "btnNavbar{{item.title}}"
  //
  private fusePerfectScrollbar: FusePerfectScrollbarDirective;

  @ViewChild(FusePerfectScrollbarDirective) set directive(theDirective: FusePerfectScrollbarDirective) {
    if (!theDirective) {
      return;
    }

    this.fusePerfectScrollbar = theDirective;

    this.navigationServiceWatcher =
      this.navigationService.onItemCollapseToggled.subscribe(() => {
        this.fusePerfectScrollbarUpdateTimeout = setTimeout(() => {
          this.fusePerfectScrollbar.update();
        }, 310);
      });
  }

  @Input() layout;
  navigation: any;
  navigationServiceWatcher: Subscription;
  fusePerfectScrollbarUpdateTimeout;
  appName = '';
  constructor(
    private sidebarService: FuseSidebarService,
    private navigationService: FuseNavigationService,
    private defaultData: DefaultDataService,
    private constants: ConstantsService,
  ) {
    // Navigation data
    this.navigation = navigation;

    // Default layout
    this.layout = 'vertical';

    this.appName = this.defaultData.AppTitle || constants.AppTitle;
  }

  ngOnDestroy() {
    if (this.fusePerfectScrollbarUpdateTimeout) {
      clearTimeout(this.fusePerfectScrollbarUpdateTimeout);
    }

    if (this.navigationServiceWatcher) {
      this.navigationServiceWatcher.unsubscribe();
    }
  }

  toggleSidebarOpened(key) {
    this.sidebarService.getSidebar(key).toggleOpen();
  }

  toggleSidebarFolded(key) {
    this.sidebarService.getSidebar(key).toggleFold();
  }
}
